const CATEGORY_TRANSLATIONS = {
  'meat-alternatives': 'Alternatives à la viande',
  'plant-based-foods': 'Aliments à base de plantes',
  'dairy-products': 'Produits laitiers',
  'beverages': 'Boissons',
  'snacks': 'Snacks',
  'sweet-snacks': 'Snacks sucrés',
  'salty-snacks': 'Snacks salés',
  'breakfast-cereals': 'Céréales du petit-déjeuner',
  'spreads': 'Pâtes à tartiner',
  'sweet-spreads': 'Pâtes à tartiner sucrées',
  'chocolate-spreads': 'Pâtes à tartiner au chocolat',
  'cheeses': 'Fromages',
  'yogurts': 'Yaourts',
  'breads': 'Pains',
  'pasta': 'Pâtes',
  'rice': 'Riz',
  'fish': 'Poissons',
  'meats': 'Viandes',
  'fruits': 'Fruits',
  'vegetables': 'Légumes',
  'frozen-foods': 'Surgelés',
  'condiments': 'Condiments',
  'sauces': 'Sauces',
  'desserts': 'Desserts',
  'biscuits-and-cakes': 'Biscuits et gâteaux',
};

export function translateCategory(rawCategory) {
  if (!rawCategory) return '';
  const cleaned = rawCategory.replace(/^[a-z]{2}:/, '').trim().toLowerCase();
  if (CATEGORY_TRANSLATIONS[cleaned]) return CATEGORY_TRANSLATIONS[cleaned];
  const fallback = cleaned.replace(/-/g, ' ');
  return fallback.charAt(0).toUpperCase() + fallback.slice(1);
}
